import { T } from '@tribeplatform/react-components/i18n'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { VerifyForm } from './VerifyForm'

export const VerifyModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header
        title={
          <T
            defaultMessage="Verify your account"
            id="Auth.Verify.Modal.Title"
          />
        }
      />
      <Modal.Content>
        <VerifyForm />
      </Modal.Content>
    </Modal>
  )
}
